/* eslint-disable import/no-named-as-default */
/* eslint-disable no-shadow */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { loadPremiumPricing } from "../../actions/premiumPricingActions";
import ActionBar from "../shared/general/ActionBar";
import FullScreenLoading from "../shared/loaders/FullScreenLoading";
import ErrorBoundary from "../shared/error/ErrorBoundary";
import tick from "./img/tick.png";
import Pricing from "./Pricing";
import {
  Wrapper,
  Header,
  HeaderText,
  HeaderTextWrapper,
  Description,
  DescriptionTitle,
  Options,
  Option,
  Tick,
  OptionText,
  SmallPrint,
  SmallPrintTitle,
  Body,
} from "./styles/premium-pricing-styles";

interface IPremiumPricingProps {
  loadPremiumPricing: () => void;
  loading: boolean;
}

export class PremiumPricing extends Component<IPremiumPricingProps, unknown> {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
    loadPremiumPricing: PropTypes.func.isRequired,
  };

  componentDidMount(): void {
    const { loadPremiumPricing } = this.props;
    loadPremiumPricing();
  }

  render(): React.ReactNode {
    const { loading } = this.props;

    return (
      <ErrorBoundary>
        <ActionBar
          title="premium pricing"
          mobileTitle="premium pricing"
          loading={loading}
        />
        {loading ? (
          <FullScreenLoading />
        ) : (
          <Wrapper>
            <Header className="animated fadeIn delay-1">
              <HeaderText className="animated fadeIn delay-4">
                <HeaderTextWrapper>
                  Managing a recruitment process and multiple recruitment
                  agencies is hard and time-consuming. We created Premium to
                  lighten your load. It&apos;s for those using the marketplace
                  that are time-poor and want to channel the majority of
                  activity through one point of contact to save time, simplify
                  comms, and reduce the admin associated with hiring.
                </HeaderTextWrapper>
              </HeaderText>
            </Header>
            <Body>
              <Description className="animated fadeIn delay-2">
                <Options className="animated fadeIn delay-5">
                  <DescriptionTitle>
                    Switch to a Premium Account and get:
                  </DescriptionTitle>
                  <Option>
                    <Tick src={tick as string} alt="Tick icon" />
                    <OptionText>
                      Time-saving concierge service* delivered by an experienced
                      Account Manager
                    </OptionText>
                  </Option>
                  <Option>
                    <Tick src={tick as string} alt="Tick icon" />
                    <OptionText>
                      Data &amp; analytics dashboard to track performance and
                      key metrics
                    </OptionText>
                  </Option>
                  <Option>
                    <Tick src={tick as string} alt="Tick icon" />
                    <OptionText>
                      Premium job listings on Hiring Hub’s marketplace
                    </OptionText>
                  </Option>
                  <Option>
                    <Tick src={tick as string} alt="Tick icon" />
                    <OptionText>Recruiter curation and management</OptionText>
                  </Option>
                  <Option>
                    <Tick src={tick as string} alt="Tick icon" />
                    <OptionText>Video screening and interviewing</OptionText>
                  </Option>
                  <Option>
                    <Tick src={tick as string} alt="Tick icon" />
                    <OptionText>Platform fee waived</OptionText>
                  </Option>
                </Options>
                <SmallPrint className="animated fadeIn delay-6">
                  <SmallPrintTitle>*Concierge services</SmallPrintTitle>
                  Think of us as your recruiting PA. Our goal is to reduce the
                  admin and communication associated with managing multiple
                  recruiters and/or recruitment processes, letting you get on
                  with your day job. We&apos;ll become an extension of your
                  team, helping with everything from salary and fee
                  benchmarking, uploading jobs, selecting and briefing agencies,
                  interviews, delivering candidate feedback, and ensuring a
                  positive agency experience to safeguard your employer brand.
                </SmallPrint>
              </Description>
              <Pricing />
            </Body>
          </Wrapper>
        )}
      </ErrorBoundary>
    );
  }
}

interface IReduxState {
  premiumPricing: {
    loading: boolean;
  };
}

const mapStateToProps = (state: IReduxState) => ({
  loading: state.premiumPricing.loading,
});

export default connect(mapStateToProps, { loadPremiumPricing })(PremiumPricing);
